import React, { Component } from "react";
import Layout from "../../../Layout/layout";
import Helmet from "react-helmet";
import AnimateTable from "../../commoncomponents/animateTable";
import "../../../styles/reports/reports.scss";
import "../../../styles/tools/colors.scss";
import { connect } from "react-redux";
import {
	setLoadingPage,
	setErrorMessage,
	setReportAssetId,
	setReportAssetName,
} from "../../../reducers/actions";
import LocationTable from "./locationTable";
import moment from "moment";
import axios from "axios";
import { apiHost } from "../../../api/apiClient";
import queryString from "query-string";


class LocationData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            assetId: "",
            assetCustomer: '',
            filter: false,
            date: new Date(),
            assetSelect: false,
            dateSelect: true,
            selectedDate: "",
            locationData: [],
            dateplaceholder: moment().format("dddd Do MMMM, YYYY"),
        };
    }
    async componentDidMount() {
        const values = queryString.parse(window.location.search);
        if (values.assetId) {
            if (values.assetDate !== undefined && values.assetDate !== "null") {
                await this.setState({
                    dataPlaceholder: moment(values.assetDate).format("dddd Do MMMM, YYYY"),
                    selectedDate: values.assetDate,
                    dateSelect: true,
                });
            }
            await this.setState({
                assetPlaceholder: values.assetName,
                assetId: values.assetId,
                assetSelect: true
            });
            this.handleCreateReport();
        }
    }

    handleAssetId = (assetId) => {
        this.setState({ assetId, assetSelect: true });
    };

    handleAssetName = (assetname) => {
        this.setState({ assetName: assetname });
    };

    handleDate = (date) => {
        this.setState({
            date,
            dateSelect: true,
            selectedDate: moment(date).format("YYYY-MM-DD"),
            dateplaceholder: moment(date).format("dddd Do MMMM, YYYY"),
        });
    };

    handleFilter = (filter) => {
        this.setState({ filter: filter });
    };

    getAssetCustomer = (asset) => {
        this.setState({ assetCustomer: asset });
    }

    handleCreateReport = async () => {
        this.setState({
            locationData:[]
          });
        this.props.setLoadingPageAction(true);
        this.props.setReportAssetIdAction(this.state.assetId);
        this.props.setReportAssetNameAction(this.state.assetName);
        try {
            let locationData = await axios.post(
                `${apiHost}/api/Report/LocationDataReport`,
                {
                    AssetId: this.state.assetId,
                    SearchDate:
                        this.state.selectedDate == ""
                            ? moment().format("YYYY-MM-DD")
                            : this.state.selectedDate,
                    Timezone: localStorage.getItem("timeZoneID"),
                    UseFiltering: false,
                },
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                }
            );
            console.log("result location", locationData.data);
            this.setState({
                locationData: locationData.data.locationData,
                isTempAEnabled: locationData.data.tempA,
                isTempBEnabled: locationData.data.tempB,
                isDriverIDEnabled: locationData.data.driverID
            });
            this.props.setLoadingPageAction(false);
        } catch (e) {
            if (e && e.response.status == "401") {
                this.props.history.push("/login");
            } else {
                this.props.setErrorMessageAction(`${e}`);
            }
            this.props.setLoadingPageAction(false);

            console.log(`😱 Axios request failed: ${e}`);
        }
    };

    render() {
        const groupTable = [
            { customer: "john", name: "jean", description: "testing" },
            { customer: "john2", name: "jean2", description: "testing" },
            { customer: "john3", name: "jean3", description: "testing" },
            { customer: "john4", name: "jean4", description: "testing" },
        ];

    return (
      <Layout>
        <Helmet>
          <title>Location Data</title>
        </Helmet>
        <div className="contentBody">
          <div
            className={
              !this.props.headerHide
                ? `contentWrapper contentWrapperSmoothRelease`
                : `contentWrapper contentWrapperSmooth`
            }
          >
            <AnimateTable
              assetPlaceHolder={this.state.assetName}
              setCustomerName={this.getAssetCustomer}
              groupTable={groupTable}
              heading="Location Data Report"
              onAssetId={this.handleAssetId}
              onAssetName={this.handleAssetName}
              onDate={this.handleDate}
              onFilter={this.handleFilter}
              onCreateReport={this.handleCreateReport}
              filtering={false}
              assetSelect={this.state.assetSelect}
              dateSelect={this.state.dateSelect}
              dateplaceholder={this.state.dateplaceholder}
              fromLocation={true}
            />

                        <LocationTable locationData={this.state.locationData}
                            assetCustomerName={this.state.assetName}
                            timeZone={this.state.date}
                            tempAEnabled={this.state.isTempAEnabled}
                            tempBEnabled={this.state.isTempBEnabled}
                            driverIDEnabled={this.state.isDriverIDEnabled}
                        />
                    </div>
                </div>
            </Layout>
        );
    }
}
const mapStateToProps = (state) => ({
    headerHide: state.headerHide,
});
const mapDispatchToProps = {
    setLoadingPageAction: setLoadingPage,
    setErrorMessageAction: setErrorMessage,
    setReportAssetNameAction: setReportAssetName,
    setReportAssetIdAction: setReportAssetId,
};

export default connect(mapStateToProps, mapDispatchToProps)(LocationData);
